"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UserExclamation: function() {
        return UserExclamation;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UserExclamation = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3ZM7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6ZM4.06189 21C4.55399 17.0537 7.92038 14 12 14C13.6564 14 15.1924 14.5023 16.4678 15.3628C16.9257 15.6716 17.5472 15.5509 17.8561 15.093C18.165 14.6352 18.0442 14.0137 17.5864 13.7048C15.9909 12.6284 14.0673 12 12 12C6.47715 12 2 16.4772 2 22C2 22.5523 2.44772 23 3 23H17C17.5523 23 18 22.5523 18 22C18 21.4477 17.5523 21 17 21H4.06189ZM20.9976 14C21.5498 13.9987 21.9986 14.4453 22 14.9976L22.0098 18.9976C22.0111 19.5498 21.5645 19.9986 21.0122 20C20.4599 20.0013 20.0111 19.5547 20.0098 19.0024L20 15.0024C19.9987 14.4502 20.4453 14.0014 20.9976 14ZM19.9998 22C19.9998 21.4477 20.4475 21 20.9998 21H21.0098C21.562 21 22.0098 21.4477 22.0098 22C22.0098 22.5523 21.562 23 21.0098 23H20.9998C20.4475 23 19.9998 22.5523 19.9998 22Z",
        fill: "currentColor"
    })
}), "UserExclamation");
const _default = UserExclamation;
